// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledSmartFormLink from '../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import LabeledString from '../../../shared/components/labeled-string';
import {buildDate} from '../../../shared/services/build-date';
import {buildNumber} from '../../../shared/services/build-number';

const PrepareAuditListItemInfo = props =>
    <div className='prepare-audit-list-item-info'>
        <div className='row'>
            <LabeledString
                className='work-order'
                data={props.auditClaim.workOrder}
                label='WORK_ORDER_NUMBER'
            />
            <LabeledLink
                className='pin'
                data={props.auditClaim.pin}
                href={`#/products/${props.auditClaim.pin}`}
                label='PIN'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledString
                className='requested'
                data={buildNumber(props.auditClaim.reimbursementDetails.requestedAmount)}
                label='REQUESTED'
            />
            <LabeledString
                className='with-additives'
                data={buildNumber(props.auditClaim.reimbursementDetails.withAdditives)}
                label='WITH_ADDITIVES'
            />
        </div>
        <div className='row'>
            <LabeledSmartFormLink
                className='credit-memo-number'
                displayText={props.auditClaim.creditMemoNumber}
                formName='CREDITMEMO'
                label='CREDIT_MEMO'
                objectId={props.auditClaim.creditMemoNumber}
            />
            <LabeledString
                className='updated'
                data={buildDate(props.auditClaim.updatedOn)}
                label='UPDATED'
            />
            <LabeledString
                className='approved'
                data={buildNumber(props.auditClaim.reimbursementDetails.approvedAmount)}
                label='APPROVED'
            />
        </div>
        <div className='row'>
            {props.auditClaim.claimType.key === 'ZZMK' ?
                <LabeledString
                    className='claim-type'
                    data={props.auditClaim.subClaimType.value}
                    label='CLAIM_TYPE'
                /> :
                    <LabeledString
                        className='claim-type'
                        data={props.auditClaim.claimType.value}
                        label='CLAIM_TYPE'
                    />
            }
        </div>
    </div>;

PrepareAuditListItemInfo.displayName = 'PrepareAuditListItemInfo';
PrepareAuditListItemInfo.propTypes = {
    auditClaim: PropTypes.instanceOf(AuditClaim).isRequired
};

export default PrepareAuditListItemInfo;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/prepare-audit-list-item-info.js